/**
 * Client entry point
 */

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import auth from './util/auth';
import { configureStore } from './store';

require('react-toastify/dist/ReactToastify.min.css');
require('react-select/dist/react-select.css');

// Initialize store
const store = configureStore(window.__INITIAL_STATE__);
const mountApp = document.getElementById('root');

if (typeof window !== 'undefined') {
  auth.checkToken(store);
  render(
    <HelmetProvider>
      <BrowserRouter>
        <App store={store} />
      </BrowserRouter>
    </HelmetProvider>,
    mountApp
  );
}

if (module.hot) {
  module.hot.accept();
}
